// extracted by mini-css-extract-plugin
module.exports = {"draggableHeader":"_39M7wfRH","editWidgetContainer":"_1__IEHv3"};